import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NotesComponent } from '../notes/notes.component';
import { MemberDashboardService } from '../member-dashboard.service';
import { ActivatedRoute } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import { CommonModule, formatDate } from '@angular/common';
import moment from 'moment';
import { NgIf } from '@angular/common';
import { MatDateRangeInput, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule, MatHint, MatLabel } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
declare var $: any;

@Component({
  selector: 'app-bmi-chart',
  standalone: true,
  imports: [CommonModule, FormsModule, MatCheckboxModule, NotesComponent, MatNativeDateModule,
    MatDateRangeInput, MatHint, MatLabel, MatFormFieldModule, MatDatepickerModule,
    HighchartsChartModule, NgIf, MatProgressSpinnerModule],
  templateUrl: './bmi-chart.component.html',
  styleUrl: './bmi-chart.component.css'
})
export class BMIChartComponent {
  @ViewChild('chart') chart: any;
  @Input() sDate: any;
  @Input() eDate: any;
  @Input() memberbasic: any;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  private chartInstance: any;
  showChart: boolean = true;
  tZone: any;
  currentDateBmi: any;
  previousDateBmi: any;
  isLoading = 1;
  timeZone: any;
  activityName: any;
  calsBurned: any;
  distCovered: any;
  distUnits: any = "Km";
  foodName: any;
  foodCals: any;
  foodCarbs: any;
  foodProteins: any;
  foodFats: any;
  memberId: any = this.route.snapshot.queryParamMap.get('memberId');

  // BMIVals: any = [];
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  endDate: any = formatDate(Date.now(), 'Y-MM-d', 'en');
  startDate: any = formatDate(new Date().setDate(new Date().getDate() - 7), 'Y-MM-d', 'en');

  vitalDetails: any;
  bmiData: any = [];
  seriesName: any = 'Pounds (lbs)';
  units: any = 'lbs';
  boneMassValue: number | null = null;
  constructor(private dashboard: MemberDashboardService, private route: ActivatedRoute) {
    var d = new Date();
    var p = new Date(new Date().setDate(new Date().getDate() - 7));
    this.currentDateBmi = d
    this.previousDateBmi = p;
  }

  ngOnInit() {
    if (this.memberbasic.timeZone && this.memberbasic.timeZone != '' && this.memberbasic.timeZone != "null") {
      this.tZone = this.memberbasic.timeZone
    } else {
      if (this.memberbasic.address?.country?.toUpperCase() === "INDIA") {
        this.tZone = 'Asia/Kolkata';
      } else {
        this.tZone = 'America/New_York';
      }
    }
    // Use input dates from parent if provided, otherwise use default dates
    const startDateToUse = this.sDate || this.startDate;
    const endDateToUse = this.eDate || this.endDate;
    this.getBMIDetails(startDateToUse, endDateToUse);
  }

  ngOnChanges(changes: SimpleChanges) {
    // React to changes in sDate or eDate inputs from parent
    if ((changes['sDate'] || changes['eDate']) && !changes['sDate']?.firstChange && !changes['eDate']?.firstChange) {
      const startDateToUse = this.sDate || this.startDate;
      const endDateToUse = this.eDate || this.endDate;
      this.isLoading = 1;
      this.getBMIDetails(startDateToUse, endDateToUse);
    }
  }
  filterByDateBmi(startDate: HTMLInputElement, endDate: HTMLInputElement) {
    if (startDate.value != '' && endDate.value != '') {
      this.startDate = startDate.value;
      this.endDate = endDate.value;
      this.isLoading = 1;
      this.getBMIDetails(startDate.value, endDate.value);
    }
  }

  setTimePeriod(period: string) {
    const today = new Date();
    let startDate: Date;

    switch (period) {
      case '1week':
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
        break;
      case '2weeks':
        startDate = new Date(today.getTime() - (14 * 24 * 60 * 60 * 1000));
        break;
      case '1month':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        break;
      case '3months':
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
        break;
      default:
        startDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
    }

    // Update the date picker values
    this.previousDateBmi = startDate;
    this.currentDateBmi = today;

    // Format dates for API calls
    const startDateStr = formatDate(startDate, 'Y-MM-d', 'en');
    const endDateStr = formatDate(today, 'Y-MM-d', 'en');

    // Update internal date variables
    this.startDate = startDateStr;
    this.endDate = endDateStr;

    // Set loading state and fetch BMI data
    this.isLoading = 1;
    this.getBMIDetails(startDateStr, endDateStr);
  }
  onVitalSelect(vital: string) {
    const vitalMap: { [key: string]: { prop: string, seriesName: string, units: string } } = {
      curWt: { prop: 'weight', seriesName: 'Pounds (lbs)', units: 'lbs' },
      bmi: { prop: 'bmiValue', seriesName: 'BMI', units: '' },
      bmr: { prop: 'bmr', seriesName: 'Calories (cal)', units: 'cal' },
      subFat: { prop: 'subcFat', seriesName: 'Percentage (%)', units: '%' },
      muscPert: { prop: 'muscPert', seriesName: 'Pounds (lbs)', units: 'lbs' },
      viscFat: { prop: 'viscFat', seriesName: 'Levels', units: '' },
      protein: { prop: 'protein', seriesName: 'Percentage (%)', units: '%' },
      boneMass: { prop: 'boneMass', seriesName: 'Pounds (lbs)', units: 'lbs' },
      tarWt: { prop: 'targetWt', seriesName: 'Pounds (lbs)', units: 'lbs' },
      bodyFat: { prop: 'bodyFat', seriesName: 'Percentage (%)', units: '%' }

    };
    const config = vitalMap[vital];
    if (!config) return;

    this.seriesName = config.seriesName;
    this.units = config.units;

    // These vitals should skip zero-value readings instead of plotting them
    const zeroSkipVitals = ['bmr', 'subFat', 'muscPert', 'viscFat', 'bodyFat'];
    const skipZero = zeroSkipVitals.includes(vital);

    const data = this.bmiData
      .filter((item: any) => !skipZero || item[config.prop] !== 0)
      .map((item: any) => {
        // Parse ISO timestamp directly to preserve exact time
        const date = new Date(item.memberTimeStamp).getTime();
        return {
          x: date,
          y: item[config.prop],
          custom: {
            memberTimeStamp: item.memberTimeStamp
          }
        };
      });

    // Force chart recreation to clear zoom state when switching vitals
    this.forceChartRecreation();
    setTimeout(() => {
      this.createGraph(data);
    }, 50);
  }

  getBMIDetails(sDate: any, eDate: any) {
    this.dashboard.getBmiReadings(this.memberId, sDate, eDate).subscribe(data => {
      this.bmiData = data;
      if (this.bmiData.length === 0) {
        this.boneMassValue = null;
        this.isLoading = 2;
        // Always show the chart, even with no data
        this.forceChartRecreation();
        setTimeout(() => {
          this.createGraph([]);
          this.resetChartZoom();
        }, 50);
        return;
      }
      // Find highest Bone Mass for the selected time range
      const boneMassArr = this.bmiData.map((item: any) => item.boneMass).filter((v: any) => v !== undefined && v !== null);
      if (boneMassArr.length > 0) {
        this.boneMassValue = Math.max(...boneMassArr);
      } else {
        this.boneMassValue = null;
      }
      const bmiData: any[] = [];
      document.getElementById('curWtId')?.click();
      for (let i = 0; i < this.bmiData.length; i++) {
        // Parse ISO timestamp directly to preserve exact time
        const date = new Date(this.bmiData[i].memberTimeStamp).getTime();
        bmiData.push({
          x: date,
          y: this.bmiData[i].weight,
          custom: {
            memberTimeStamp: this.bmiData[i].memberTimeStamp
          }
        });
      }

      // Force chart recreation and reset zoom for new data
      this.forceChartRecreation();
      setTimeout(() => {
        this.createGraph(bmiData);
        this.resetChartZoom();
      }, 50);
    });
  }

  createGraph(vitals: any) {
    let tZone = this.tZone;
    let unit = this.units;
    this.chartOptions = {
      chart: {
        backgroundColor: '#F9F9F9',
        type: 'line',
        panKey: 'shift',
        panning: {
          enabled: true,
          type: 'x'
        },
        zooming: {
          type: 'x'
        }
      },
      title: { text: 'Health Vitals' },
      xAxis: [{
        type: 'datetime',
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S.%L',
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%a,<br/>%b %e',
          week: '%a,<br/>%b %e',
          month: '%b \'%y',
          year: '%Y'
        }
      }],
      credits: {
        enabled: false
      },
      yAxis: [{
        lineColor: 'black',
        lineWidth: 1,
        title: {
          text: this.seriesName
        }
      }],
      tooltip: {
        formatter: function () {
          if (this.x !== undefined) {
            // Use original memberTimeStamp from custom property to show exact time
            const customData = (this.point as any).options?.custom || {};
            const originalTimestamp = customData.memberTimeStamp || this.x;
            const dateObj = new Date(originalTimestamp);
            let d = moment(dateObj).format('ddd, MMM DD');
            let t = moment(dateObj).format('HH:mm:ss');
            return d + ' at ' + t + '</b> <br> Value: <b>' + this.y + ' ' + unit + '</b>';
          }
          return 'Vital: ' + this.y;
        },

        backgroundColor: 'rgba(0,0,0, 0.6)',
        borderWidth: 1,
        shadow: true,
        style: {
          color: '#fff',
          fontSize: '12pt',
          fontFamily: 'Urbanist, sans-serif'
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        },
        series: {
          marker: {
            symbol: 'circle',
            fillColor: '#000408',
            enabled: true,
            radius: 3,
            lineWidth: 1,


          }
        },
      },
      series: [{
        data: vitals,
        type: 'line',
        color: '#000408',
        showInLegend: false,
      }
      ],
    };

    this.chartOptions.time = {
      timezone: tZone
    }

    // Hide loading spinner after chart is created
    this.isLoading = 2;

    // Add chart callback to capture instance for zoom control
    this.chartOptions.chart!.events = {
      load: this.chartCallback
    };
  }

  // Chart callback to capture chart instance
  chartCallback = (chart: any) => {
    // The chart parameter is actually an event object, get the actual chart from target
    const actualChart = chart.target;
    this.chartInstance = actualChart;
  }

  // Reset chart zoom
  private resetChartZoom(): void {
    const chart = this.getChartInstance();
    if (chart && chart.xAxis && chart.xAxis[0] && typeof chart.xAxis[0].setExtremes === 'function') {
      chart.xAxis[0].setExtremes(null, null);
    }
  }

  // Force chart recreation when data changes
  private forceChartRecreation(): void {
    // Hide and show chart to force recreation
    this.showChart = false;
    setTimeout(() => {
      this.showChart = true;
    }, 10);
  }

  // Get chart instance from ViewChild if not available
  private getChartInstance(): any {
    if (this.chartInstance) {
      return this.chartInstance;
    }

    // Try to get from ViewChild
    if (this.chart && this.chart.chart) {
      this.chartInstance = this.chart.chart;
      return this.chartInstance;
    }

    return null;
  }
}
